import './ui/styles.css';
import { AetherloomGame } from './app/game';

const canvas = document.getElementById('game-canvas') as HTMLCanvasElement | null;
const uiRoot = document.getElementById('ui-root');

if (!canvas || !uiRoot) {
  throw new Error('Aetherloom: missing #game-canvas or #ui-root');
}

// Prevent pull-to-refresh / browser gestures during play
document.body.addEventListener(
  'touchmove',
  (e) => {
    if ((e.target as HTMLElement).closest('.world-map, .panel')) return;
    e.preventDefault();
  },
  { passive: false }
);

const game = new AetherloomGame(canvas, uiRoot);

// Dev inspection (game also assigns window.__aetherloom)
if (import.meta.env.DEV) {
  (window as unknown as { __aetherloomGame: typeof game }).__aetherloomGame = game;
}
